// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import React, { useMemo } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';

import { fetchStudioByUuid } from '../../../../store/studio/studioActions';

import { PopOver } from '../../../UI/PopOver/PopOver';
import { CardLink } from '../../../UI/CardLink/CardLink';

import styles from '../Navigation.module.css';

import button from '../../../UI/Button/Button.module.css';

export const StudioNavigation = () => {
  const companyUuid = useSelector(state => state.companies?.company?.company_uuid, shallowEqual);
  const { studios, studioUuid, studioName } = useSelector(state => {
    const s = state.studio;
    return {
      studios: s.studios,
      studioUuid: s.studio?.studio_uuid,
      studioName: s.studio?.name,
    };
  }, shallowEqual);

  const dispatch = useDispatch();

  const filteredStudiosByCompany = useMemo(
    () => studios?.filter(studio => studio.company_uuid === companyUuid) || [],
    [studios, companyUuid]
  );

  const handleClick = (studioUuid, setIsOpen) => {
    dispatch(fetchStudioByUuid(studioUuid));
    if (setIsOpen) {
      setIsOpen(false); // Close popover after selection
    }
  };

  return (
    <PopOver
      color=''
      classname={button.btnNavigation}
      hoverEffect={true}
      buttonText={studioUuid ? studioName : 'Select studio'}
    >
      {({ setIsOpen }) => (
        <div className={styles.navItemContainer}>
          {filteredStudiosByCompany.map(studio => (
            <CardLink
              key={studio.studio_uuid}
              view={false}
              grid={false}
              onClick={() => handleClick(studio.studio_uuid, setIsOpen)}
            >
              <p>{studio.name}</p>
            </CardLink>
          ))}
        </div>
      )}
    </PopOver>
  );
};
